import { useSelector } from 'react-redux';

import { EDealType } from 'shared/repositories/valuation-offer-history/entities/offer_history/HouseOfferHistoryRequestV4Schema';
import { selectDealType } from 'shared/selectors';

export const useAuthErrorTitle = (): string => {
  const dealType = useSelector(selectDealType);

  return dealType === EDealType.Sale
    ? ', чтобы просматривать снятые с продажи объявления'
    : ', чтобы просматривать снятые с публикации объявления';
};
